const ReceiptItem = ({ label, value, highlight }) => (
    <div className="flex justify-between items-center py-1">
        <span className="text-gray-600">{label}</span>
        <span className={`${highlight ? 'text-primary font-medium' : 'text-gray-800'}`}>
            {value}
        </span>
    </div>
);

export default ReceiptItem;